import { FETCH_APPLINKS, type FetchAppLinksAction } from '../../actions/fetch-applinks';
import {
	FETCH_APPLINKS_FAILURE,
	type FetchAppLinksFailureAction,
} from '../../actions/fetch-applinks-failure';
import {
	FETCH_APPLINKS_SUCCESS,
	type FetchAppLinksSuccessAction,
} from '../../actions/fetch-applinks-success';

import type { AppLinksState } from './types';

type AppLinksHandledAction =
	| FetchAppLinksSuccessAction
	| FetchAppLinksFailureAction
	| FetchAppLinksAction;

export const defaultState: AppLinksState = {
	isLoaded: false,
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	state: AppLinksState = defaultState,
	action: AppLinksHandledAction,
): AppLinksState => {
	switch (action.type) {
		case FETCH_APPLINKS:
			return {
				...state,
				error: undefined,
				isLoaded: false,
			};
		case FETCH_APPLINKS_SUCCESS:
			return {
				appLinks: action.payload,
				error: undefined,
				hasConfluenceServer: action.payload.some((appLink) => appLink.isServer),
				isLoaded: true,
			};
		case FETCH_APPLINKS_FAILURE:
			return {
				appLinks: [],
				error: action.payload,
				hasConfluenceServer: false,
				isLoaded: true,
			};
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
